import { Icon } from "icons";
import { useTranslation } from "react-i18next";
import { Tooltip, TooltipContent, TooltipTrigger, useToast } from "ui";

import { useClipboard } from "src/hooks/useClipboard";

interface NotificationAthleteInfoProps {
  description: string;
  athleteEmail: string | null;
}

export function NotificationAthleteInfo(props: NotificationAthleteInfoProps) {
  const { t } = useTranslation();
  const toast = useToast();
  const clipboard = useClipboard();
  const athleteEmail = props.athleteEmail;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          className="ml-1 inline-flex align-text-bottom text-muted-foreground"
          onClick={(event) => event.stopPropagation()}
        >
          <Icon
            name="tabler-info-circle"
            className="size-4"
            strokeWidth={1.8}
          />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side="bottom"
        className="max-w-72 space-y-1.5 text-left font-normal"
        onClick={(event) => event.stopPropagation()}
      >
        <p>{props.description}</p>
        {athleteEmail && (
          <button
            type="button"
            className="inline-flex items-center gap-1 underline underline-offset-2"
            onClick={async () => {
              await clipboard.copy(athleteEmail);
              toast.toast({ title: t("notification.emailCopied") });
            }}
          >
            {athleteEmail}
            <Icon
              name={clipboard.state.isCopied ? "tabler-check" : "tabler-copy"}
              className="size-3.5"
            />
          </button>
        )}
      </TooltipContent>
    </Tooltip>
  );
}
